import { GenerationSaleSubKind } from '@ebalance/proto/bfftypes/v1/plan_submission_pb'
import { useTranslation } from 'react-i18next'

import { RadioButton } from '@enechain/ecloud-designsystem'

import {
  PLAN_CATEGORY_OPTIONS,
  planCategoryLabel,
} from '~/pages/AdminOcctoMaster/tabs/GenerationSalesPlanMaster/models/planCategory'

type Props = {
  value: GenerationSaleSubKind
  onChange: (value: GenerationSaleSubKind) => void
}

/**
 * 発電販売計画マスタ タブ専用の計画区分フィルタ (通常電源 / FIT 特例電源、
 * AC-03 / AC-04)。デフォルトは通常電源 (呼び出し側の初期 state で担保)。
 * design (`design/admin/occto.html` #occto-plancat-group) は `role="radiogroup"`
 * の 2 択ラジオ (既定 通常電源) であり、 DS 側のルール (design/specs/tech-spec.md
 * §13「フィルター項目は radio に統一。 segmented は画面/ビュー/モード切替専用」)
 * とも一致するため、 トグルボタンではなく DS RadioButton を使う。
 * 枠・ラベルは自前で持たず部品 (radio) だけを返し、 共通 `MasterFilterToolbar` の
 * afterArea へ差し込んでもらう (開閉式のカードで エリア → 計画区分 → 検索 の順に並べ、
 * ラベルと要約の値は呼び出し側が渡す)。
 */
export const PlanCategoryFilter = ({
  value,
  onChange,
}: Props): React.ReactElement => {
  // 言語切替で再描画させるために購読だけする (ラベルは planCategoryLabel が i18next から引く)
  useTranslation()

  // planCategoryLabel は i18next 経由でラベルを引く (= `t` を引数に取らない) ため、
  // useMemo せず毎 render 組み立てる。 memo 化すると deps に `t` を書いても
  // callback 内で参照されず exhaustive-deps に弾かれ、言語切替に追従できない。
  const radios = PLAN_CATEGORY_OPTIONS.map((kind) => ({
    value: String(kind),
    label: planCategoryLabel(kind),
  }))

  return (
    <RadioButton
      direction="row"
      onValueChange={(details) => {
        if (details.value !== null) {
          onChange(Number(details.value) as GenerationSaleSubKind)
        }
      }}
      radios={radios}
      value={String(value)}
    />
  )
}
